export default "__VITE_ASSET__b9c738c1__"